import { REDUX_ACTIONS, GAME_ID } from 'a/inkBlottJr/data/constants';

const initState = {
  width: 0,
  height: 0,
  x: 0,
  y: 0,
};

const screenPositionReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.SAVE_SCREEN_COORDINATES:
      return {
        ...state,
        width: payload.width,
        height: payload.height,
        pageX: payload.pageX,
        pageY: payload.pageY,
      };

    default:
      return state;
  }
};

export default screenPositionReducer;
